import React from 'react'
import styled from 'styled-components'

import ShapesImage from '@/assets/images/shapes/footer.svg'
import { DropdownNavMenu } from '@/components/common/header/dropdown-nav-menu'

import { Shapes } from './shapes'

const Section = styled.section`
  position: relative;
`

const ShapesFooter = styled(Shapes)`
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);

  &:before {
    background-size: cover;
  }
`

export const Footer = () => (
  <Section>
    <ShapesFooter source={ShapesImage} />
    <DropdownNavMenu isFooter />
  </Section>
)
